const pathname = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));

const platformOld = 'ow_aem';

export const publicResourcesPath = `${window.location.origin}${pathname}`;

export const VALUES = {
  channelSuffix: 'LIFECYCLE',
  nodeName: 'SCRIPT',
  clientJSClass: '-script',
  responseTimeOutMs: 15000,
  stateComplete: 'complete',
  stateLoaded: 'loaded',
  iFrameContextUrl: `${publicResourcesPath}/BackportPluginComponent/blank.html`,

  // These were in PAYLOAD object, do they need to be differentiated?
  // Assumption: no, they do not need to
  instanceId: null, // pluginName as instanceId - eg: rcc or scc
  styleSheetUrl: null,
  data: {
    params: {},
  },
};

export const MESSAGE_BUS_MESSAGETYPE = {
  init: 'init',
  update: 'update',
  destroy: 'destroy',
};

export const MESSAGE_BUS_EVENTS = {
  loaderOn: 'loaderOn',
  loaderOff: 'loaderOff',
  overlayOpen: 'overlayOpen',
  overlayClose: 'overlayClose',
  overlayIsOpened: 'overlayIsOpened',
  overlayContentIsLoaded: 'overlayContentIsLoaded',
  overlayIsClosed: 'overlayIsClosed',
  dialogCreated: 'dialogCreated',
  dialogRequest: 'dialogRequest',
  analyticsEventTriggered: 'analyticsEventTriggered',
};

export const CIAM_LOCAL_STORAGE_KEYS: Record<string, string> = {
  everLoggedIn: `${platformOld}_everLoggedIn`,
  logoutRequested: 'logout-requested',
};

export const CIAM_SESSION_STORAGE_KEYS: Record<string, string> = {
  ciamLoginUrl: `${platformOld}_ciamLoginUrl`,
  ciamLogoutUrl: `${platformOld}_ciamLogoutUrl`,
  ciamRegistrationUrl: `${platformOld}_ciamRegistration`,
  ciamRegistrationConfirmUrl: `${platformOld}_confirmregistration`,
  ciamPasswordResetUrl: `${platformOld}_passwordreset`,
  ciamEmailChangeUrl: `${platformOld}_changeemail`,
  apiGatewayConfiguration: `${platformOld}_apiGatewayConfiguration`,
  email: `${platformOld}_email`,
  firstname: `${platformOld}_firstname`,
  gender: `${platformOld}_gender`,
  jws: `${platformOld}_jws`,
  jwe: `${platformOld}_jwe`,
  lastname: `${platformOld}_lastname`,
  loginLinkText: `${platformOld}_loginLinkText`,
  loginstate: `${platformOld}_loginstate`,
  logoutLinkText: `${platformOld}_logoutLinkText`,
  name: `${platformOld}_name`,
  roles: `${platformOld}_roles`,
  sub: `${platformOld}_sub`,
  phone: `${platformOld}_phone`,
  consent: `${platformOld}_consent`,
  consentDoc: `${platformOld}_doc_consent`,
  wkoUserDataExtended: `${platformOld}_wkoUserDataExtended`,
};

export const WKO_NAMES: Record<string, string> = {
  anonymousUser: 'AnonymousUser',
  authentication: 'Authentication',
  locale: 'Locale',
  user: 'User',
  userAssociatedVehicles: 'UserAssociatedVehicles',
  selectedAssociatedVehicle: 'SelectedAssociatedVehicle',
  selectedVehicleModel: 'SelectedVehicleModel',
  selectedAssociatedVehicleDealers: 'SelectedAssociatedVehicleDealers',
  DealerContext: 'DealerContext',
};

export const ME_SESSION_STORAGE_KEYS: Record<string, string> = {
  profilepicture: `${platformOld}_profilepicture`,
  wkoUserData: `${platformOld}_wkoUserData`,
  openedVehicleRelocation: `${platformOld}_openedVehicleRelocation`,
  openedProductConsentWizard: `${platformOld}_openedProductConsentWizard`,
  userAssociatedDealers: `${platformOld}_userAssociatedDealers`,
  missingDataConfig: `${platformOld}_missingDataConfig`,
  openedNationalConsent: `${platformOld}_openedNationalConsent`,
  openedDoC: `${platformOld}_consent`,
  marketLookupTable: `${platformOld}_marketLookupTable`,
  marketRedirectRejected: `${platformOld}_marketRedirectRejected`,
  customerConsentForProductInformation: `${platformOld}_customerConsentForProductInformation`,
};

export const ME_SESSION_STORAGE_KEYS_USER_DATA = [
  'profilepicture',
  'wkoUserData',
  'openedVehicleRelocation',
  'userAssociatedDealers',
  'missingDataConfig',
  'openedNationalConsent',
  'openedDoC',
  'consent',
  'marketLookupTable',
  'marketRedirectRejected',
  'customerConsentForProductInformation',
  'openedProductConsentWizard',
];

export const VEHICLE_CONTEXT_SESSION_STORAGE_KEYS: Record<string, string> = {
  userAssociatedVehicles: `${platformOld}_userAssociatedVehicles`,
  selectedAssociatedVehicle: `${platformOld}_selectedAssociatedVehicle`,
  selectedVehicleModel: `${platformOld}_selectedVehicleModel`,
};

export const VEHICLE_CONTEXT_SESSION_STORAGE_KEYS_LOGGED_USER_DATA: string[] = [
  'userAssociatedVehicles',
  'selectedAssociatedVehicle',
];

export const WKO_FIELDS: Record<string, any> = {
  user: {
    id: 'sub',
    firstName: 'firstname',
    lastName: 'lastname',
    email: 'email',
  },
  authentication: {
    jwe: 'jwe',
    jwt: 'jws',
  },
};

export const DEALER_CONTEXT_STORAGE_FIELDS: Record<string, string> = {
  dealerContext: `${platformOld}_dealerContext`,
};

export const PLUGIN_COMPONENT_EVENTS = {
  pluginComponentInitialized: 'plugincomponent:contextInitialized.nn',
  plugincomponentSendUpdateMessage: `plugincomponent:sendUpdateMessage.nn`,
};
